import React from "react";

export const ThanksScreen = () => {
  return (
    <div className="quiz-container">
      <div className="winner-container centerElement">
        <div className="winner-header">
          <div className="winner-icon">
            <img src="/Images/happy-face.png" alt="Happy Face" />
          </div>
          <h2 className="question-title">Thanks for participating!</h2>
          <p>We appreciate your participation in our contest!</p>
        </div>
      </div>
    </div>
  );
};
